import { useMutation } from '@hooks/reactQuery';

import { removeMiddlewareSMO } from '@api/middlewareSMO';

import { MIDDLEWARE_SMO_REMOVE } from '@constants/queryKeys';

import useInvalidateMiddlewareSMO from './useInvalidateMiddlewareSMO';

interface IUseMutateMiddlewareSMORemoveReturned {
	removeMiddlewareSMO: (id: string) => void;
	isLoadingRemoveMiddlewareSMO: boolean;
}

const useMutateMiddlewareSMORemove = (handleCloseModal: () => void): IUseMutateMiddlewareSMORemoveReturned => {
	const invalidateMiddlewareSMO = useInvalidateMiddlewareSMO();

	const {
		isLoading,
		mutate,
	} = useMutation<string>({
		mutationKey: [MIDDLEWARE_SMO_REMOVE],
		mutationFn: removeMiddlewareSMO,
		onSuccess: () => {
			handleCloseModal();

			return invalidateMiddlewareSMO();
		},
	});

	return {
		removeMiddlewareSMO: mutate,
		isLoadingRemoveMiddlewareSMO: isLoading,
	};
};

export default useMutateMiddlewareSMORemove;
